var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"execution"},[_c('basic-container',[_c('el-scrollbar',{staticClass:"main"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }